<template >
<div class="container" v-if="lesson">
   
   <div class="row">
     <div class="col-12">

    <div class="card mt-5 mb-5" >
      <div class="card-header">
        <div class="row">
          <div class="col col-expand"><h5 class="text-primary">Хичээл орлож заах багш</h5>
          <span class="text-danger"></span>
          </div>
          <div class="col col-auto" >
            <button type="button" class="btn btn-danger btn-sm mr-2" @click="_addGroup">
              Багш нэмэх
            </button>

          </div>

        </div>
      </div>
      <div class="card-body">
        <table class="table table-sm table-bordered" v-if="sharedTeachers && sharedTeachers.length>0">
            
            <tr v-for="(teacher, index) in sharedTeachers">
              <td>{{index+1}}. </td>
              <td >
                <div>Нэр: {{teacher.name}}</div>
                <div>Овог: {{teacher.lastname}}</div>
                <div>Имэйл: {{teacher.email}}</div>

              </td>
              <td >
                <div class="btn-group-sm btn-group-horizontal">
                  <button  v-if="currentUser!=null && userProfile!=null" type="button" class="btn btn-outline-danger btn-sm mr-3" @click="deleteTeacher(teacher.ref)">
                    багш хасах
                  </button>

                </div>
                
              </td>
            </tr>
        </table>
        <div v-else class="alert alert warning text-center">Одоогоор багш нэмээгүй байна.</div>
      </div>
    </div>


      <!-- Modal -->
      <div class="modal fade" id="groupModal" tabindex="-1" role="dialog" aria-labelledby="groupModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="groupModalLabel">Багш нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">

                <div class="form-group">
                  <label for="exampleFormControlSelect1">Сектор:</label>
                  <select class="form-control" v-model="selectedSector" >
                    <option v-for="(sector, index) in sectors" v-bind:value="sector.ref">{{sector.name}}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">Багш:</label>
                  <select class="form-control" v-model="selectedTeacher" >
                    <option v-for="(teacher, index) in teachers" v-bind:value="teacher.ref">{{teacher.name}}-{{teacher.email}}</option>
                  </select>
                </div>

                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="_addProgram" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>

     </div>

   </div>
</div>
    
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode'
export default {
    name: "ILessonShare",

    data() {
      return {
          lesson: null,
          topics:[],
          types:[],
          selectedType:null,
          studentsText:'',
          selectedTopic:null,
          tmpStudents:[],
          display:0,
          tagText:null,
          schools:[],
          school:null,
          department:null,
          program:null,
          selectedGroup:null,
          sharedTeachers:[],
          sectors:[],
          selectedSector:null,
          teachers:[],
          selectedTeacher:null
          
      };
    },

    watch: {
      selectedSector: function (val) {
        this.selectedTeacher=null;
        if(val){
          fb.db.collection("schools/"+this.schoolId+"/teachers").where("sector", "==", val).orderBy("name").get().then(docs=>{
            if(docs && !docs.empty){
              this.teachers=[];
              for(const tdoc of docs.docs){
                let item=tdoc.data();
                item.id=tdoc.id;
                item.ref=tdoc.ref;
                this.teachers.push(item);
              }
            }
          });
        }
        else{
          fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name").get().then(docs=>{
            if(docs && !docs.empty){
              this.teachers=[];
              for(const tdoc of docs.docs){
                let item=tdoc.data();
                item.id=tdoc.id;
                item.ref=tdoc.ref;
                this.teachers.push(item);
              }
            }
          });
        }
      }
    },
    methods: {
        
      _getQA(){
        fb.db.collection("schools/"+this.schoolId+"/sectors").get().then(docs=>{
          if(docs && !docs.empty){
            this.sectors=[];
            for(const sectorDoc of docs.docs){
              let item=sectorDoc.data();
              item.id=sectorDoc.id;
              item.ref=sectorDoc.ref;
              this.sectors.push(item);
            }
          }
        });

          fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).onSnapshot(doc=> {
              let lesson=doc.data();
              lesson.id=doc.id;
              this.lesson=lesson;

              // if(this.lesson.sharedTeachers && this.lesson.sharedTeachers.length>0){
                this.sharedTeachers=[];
                for(const tref of this.lesson.sharedTeachers){
                  tref.get().then(tdoc=>{
                    if(tdoc.exists){
                      let item=tdoc.data();
                      item.id=tdoc.id;
                      item.ref=tdoc.ref;
                      this.sharedTeachers.push(item);
                    }
                  });
                }
              // }

            
          }); 

      },
      _addGroup(){
        this.selectedTeacher=null;
        this.selectedGroups=[];
        $('#groupModal').modal('toggle');
      },
      
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      _addProgram(){
        if(this.schoolId && this.selectedTeacher){
          fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).update({
            sharedTeachers: fb.firestore.FieldValue.arrayUnion(this.selectedTeacher)
          });
        }
        else{
          alert("Та мэдээллээ бүрэн оруулна уу.");
        }
      },

      toggleDepartmentFilter(department, list){
          if(this.isInDepartmentFilter(department, list)==true){

              this.removeFromDepartmentFilter(department, list);
          }
          else{
            list.push(department);
          }
      },
      isInDepartmentFilter(department, list){
          var exists=false;
          for(const current of list){

            if(current && current.id && current.id==department.id){
                exists=true;
                break;
            }
          }
          return exists;
      },
      removeFromDepartmentFilter(department, list){
        var exists=false;
        var index=0;
        var i=0;
        for(const current of list){
          if(current && current.id && current.id==department.id){
              exists=true;
              index=i;
              break;
          }
          i++;
        }
        if(exists && exists==true){
          list.splice(index, 1);
        }
      },
      async deleteTeacher(tref){
        if(this.schoolId && tref){
          await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).update({
            sharedTeachers: fb.firestore.FieldValue.arrayRemove(tref)
          });
          this._getQA();
        }
        else{
          alert("Та мэдээллээ бүрэн оруулна уу.");
        }
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
    },
    props: {
      schoolId:{
        required:true
      },
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

